import React from 'react';
import PropTypes from 'prop-types';

export default function RefereeIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 16" fill={color} {...rest}>
      <path
        d="M21.8898 0.720613H16.0613L14.7503 2.03146H12.7476L11.4368 0.720613H8.50542C4.9574 0.720613 1.99368 3.26466 1.33921 6.62401C0.561072 6.88636 0 7.62054 0 8.48716C0 9.45141 0.694217 10.2521 1.60978 10.4205C2.60435 13.2722 5.31891 15.3247 8.50542 15.3247C12.3592 15.3247 15.5253 12.3234 15.7896 8.53558L22.4236 5.87989L23.6849 3.26278C24.0941 2.41349 24.1048 1.73228 23.7167 1.23807C23.191 0.568492 22.2298 0.662362 21.8898 0.720613ZM22.3381 2.61372L21.329 4.70768L14.3124 7.51662V8.02258C14.3124 11.2247 11.7074 13.8297 8.50542 13.8297C5.30333 13.8297 2.69833 11.2247 2.69833 8.02258C2.69833 4.8206 5.30333 2.21561 8.50542 2.21561H10.8177L12.1285 3.52645H15.3694L16.6804 2.21561H21.9595L22.0382 2.21462L22.1107 2.20015C22.2325 2.17591 22.3898 2.17022 22.4952 2.18259C22.4797 2.26446 22.4398 2.40298 22.3381 2.61372Z"
        fill="#00001B"
      />
    </svg>
  );
}

RefereeIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

RefereeIcon.defaultProps = {
  size: 18,
  color: '#000',
};
